// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderDetailsButtonSetStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";
import RefreshCcw from "@insite/mobius/Icons/RefreshCcw";
import RotateCcw from "@insite/mobius/Icons/RotateCcw";
import X from "@insite/mobius/Icons/X";
import { linkLikeButtonCss } from "@sc/App/SharedStyles/MyAccountDetailsStyles";
import Email from "@sc/XDL/Icons/Email";
import Print from "@sc/XDL/Icons/Print";
import { generateButtonLinkStyle, mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

orderDetailsButtonSetStyles.printButton = {
    ...mergeWithCss(generateButtonLinkStyle(Print), linkLikeButtonCss),
};

orderDetailsButtonSetStyles.shareEntityButtonStyles = {
    button: {
        ...mergeWithCss(generateButtonLinkStyle(Email), linkLikeButtonCss),
    },
};

orderDetailsButtonSetStyles.reorderButton = {
    ...mergeWithCss(generateButtonLinkStyle(RotateCcw), linkLikeButtonCss),
};

orderDetailsButtonSetStyles.rmaButton = {
    ...mergeWithCss(generateButtonLinkStyle(RefreshCcw), linkLikeButtonCss),
};

orderDetailsButtonSetStyles.cancelButton = {
    ...mergeWithCss(generateButtonLinkStyle(X), linkLikeButtonCss),
};

orderDetailsButtonSetStyles.spinner = {
    size: 22,
    css: css`
        margin: 8px;
    `,
};

orderDetailsButtonSetStyles.buttonsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px 24px;
    `,
};

orderDetailsButtonSetStyles.buttonWrapper = {
    css: css`
        margin: 0;
        min-width: 45px;
    `,
};
